import React, { useMemo, useContext } from 'react';
import useHotelSelector from './HotelSelector.hook';
import Loader from '../../shared/loaders/Loader';
import Page from '../../shared/layouts/Page';
import { Form } from 'antd';
import CustomButton from '../CustomButton/CustomButton';
import FormItem from '../FormItem/FormItem';
import { LanguageContext } from '../../shared/contexts/Language.context';
import { ThemeContext } from '../../shared/contexts/Theme.context';

export default function HotelSelector() {
  const { state, actions } = useHotelSelector();
  const {
    actions: { translate },
  } = useContext(LanguageContext);

  const { state: theme } = useContext(ThemeContext);

  const fieldHotel = useMemo(() => {
    let options = state.chainHotels?.hotels || [];
    options = options.map(({ id, name }) => ({ value: id, text: name })) || [];
    return { key: 'hotelId', label: 'Hotel', required: true, type: 'select', options };
  }, [state.chainHotels]);

  return (
    <Page
      footer={
        state.loading ? null : (
          <CustomButton
            disabled={!state.hotelId}
            htmlType="submit"
            text={translate('continue')}
            form="HotelSelector"
          />
        )
      }
    >
      {state.loading || !theme ? (
        <Loader></Loader>
      ) : (
        <Form
          name="HotelSelector"
          onValuesChange={changeValues => {
            if (changeValues && changeValues.hotelId) {
              actions.setHotel(changeValues.hotelId);
            }
          }}
          onFinish={({ hotelId }) => {
            actions.selectHotel(hotelId);
          }}
        >
          <div className={'form-title-container'}>
            <h1 className={'form-title'}>{translate('hotelSelector.title')}</h1>
          </div>

          <FormItem key={fieldHotel.key} field={fieldHotel} />

          <style jsx>
            {`
              .form-title-container {
                width: 100%;
                display: flex;
                justify-content: center;
              }

              .form-title {
                color: ${theme.titleColor};
                margin: 30px 0 40px;
                text-align: center;
                width: 60%;
              }
            `}
          </style>
        </Form>
      )}
    </Page>
  );
}
